import { useCallback, useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  StyledWrapper,
  StyledTitle,
  ButtonContainer,
  StyledImageTitle,
} from "./SignUp.style";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import { addUserRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import { signUpSchema, validateImg } from "validations";
import { convertNum } from "helper/convert-num";
import { provinces } from "constants/provinces";
import { cities } from "constants/cities";
import Upload from "components/shared/Upload";
import ProgressBarCM from "components/shared/ProgressBar";

const formList = [
  {
    label: "نام و نام خانوادگی",
    type: "text",
    id: "full_name",
    required: true,
  },
  { label: "تلفن همراه", type: "tel", id: "phone_number", required: true },
  { label: "رمز عبور", type: "text", id: "password", required: true },
  { label: "ایمیل", type: "email", id: "email" },
  { label: "کد پستی", type: "tel", id: "postal_code", required: true },
  { label: "آدرس", type: "tel", id: "address", required: true },
];

export default function SignUp() {
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signUpSchema),
  });
  const [userData, setUserData] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [selectedCity, setSelectedCity] = useState({});
  const [active_card_number, setactive_card_number] = useState({
    url: null,
    isChanged: false,
  });
  const [business_license, setbusiness_license] = useState({
    url: null,
    isChanged: false,
  });
  const [rose_head_panel, setrose_head_panel] = useState({
    url: null,
    isChanged: false,
  });
  const [national_card, setnational_card] = useState({
    url: null,
    isChanged: false,
  });
  const [first_page_of_birth_certificate, setfirst_page_of_birth_certificate] =
    useState({
      url: null,
      isChanged: false,
    });

  //////////////// FORM ////////////////
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        addUserRequest(
          {
            active_card_number,
            business_license,
            rose_head_panel,
            national_card,
            first_page_of_birth_certificate,
            ...data,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });
    if (res) {
      reset({
        full_name: "",
        phone_number: "",
        password: "",
        email: "",
        state: "",
        city: "",
        postal_code: "",
        address: "",
      });
      Toast({ type: "success", title: "ثبت نام" });
      setactive_card_number({ url: null, isChanged: false });
      setbusiness_license({ url: null, isChanged: false });
      setrose_head_panel({ url: null, isChanged: false });
      setnational_card({ url: null, isChanged: false });
      setfirst_page_of_birth_certificate({ url: null, isChanged: false });
    }
  };

  ///////////////// handle image ////////////////
  const handleChangeImageactive_card_number = (val) => {
    validateImg(val);
    setactive_card_number({ url: val, isChanged: true });
  };
  const handleChangeImagebusiness_license = (val) => {
    validateImg(val);
    setbusiness_license({ url: val, isChanged: true });
  };
  const handleChangeImagerose_head_panel = (val) => {
    validateImg(val);
    setrose_head_panel({ url: val, isChanged: true });
  };
  const handleChangeImagenational_card = (val) => {
    validateImg(val);
    setnational_card({ url: val, isChanged: true });
  };
  const handleChangeImagefirst_page_of_birth_certificate = (val) => {
    validateImg(val);
    setfirst_page_of_birth_certificate({ url: val, isChanged: true });
  };

  return (
    <DrawerCM title="ثبت نام کاربر همکار">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container spacing={1}>
          <Grid item mt={3}>
            <BackButton />
          </Grid>

          <Grid item mb={3} xs={12}>
            <StyledWrapper>
              <StyledTitle>اطلاعات کاربر همکار</StyledTitle>
              <Grid container>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField
                    id={"type"}
                    label={"نوع کاربر"}
                    variant="outlined"
                    required
                    fullWidth
                    value={"کاربر همکار"}
                    {...register("type")}
                    error={Boolean(errors["type"])}
                    helperText={errors["type"]?.message}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                {formList.map((items, index) => (
                  <Grid
                    item
                    md={formList.length - 1 === index ? 12 : 6}
                    xs={12}
                    p={1.5}
                    key={"add-user" + index}
                  >
                    <TextField
                      id={items.id}
                      label={items.label}
                      variant="outlined"
                      required={items.required}
                      fullWidth
                      {...register(items.id)}
                      disabled={items.readOnly}
                      error={Boolean(errors[items.id])}
                      helperText={errors[items.id]?.message}
                    />
                  </Grid>
                ))}
                <Grid item md={6} xs={12} p={1.5}>
                  <FormControl fullWidth>
                    <InputLabel id="select-state">استان</InputLabel>
                    <Select
                      labelId="select-state"
                      label="استان"
                      value={selectedState?.name}
                      defaultValue={userData?.state}
                      id="state"
                      {...register("state")}
                      error={Boolean(errors.state)}
                      helperText={errors.state?.message}
                      onChange={(e) =>
                        setSelectedState({
                          name: e.target.value,
                        })
                      }
                    >
                      {provinces.data?.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.name}
                          style={{
                            direction: "rtl",
                          }}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <FormControl fullWidth>
                    <InputLabel id="select-city">شهر</InputLabel>
                    <Select
                      label="شهر"
                      labelId="select-city"
                      value={selectedCity?.name}
                      defaultValue={userData?.city}
                      id="city"
                      {...register("city")}
                      error={Boolean(errors.city)}
                      helperText={errors.city?.message}
                      onChange={(e) =>
                        setSelectedCity({
                          name: e.target.name,
                        })
                      }
                    >
                      {cities.data
                        ?.filter(
                          (item) =>
                            item.province_id ===
                            provinces.data?.find((item) =>
                              selectedState.name === undefined
                                ? item.name === userData.state
                                : item.name === selectedState.name
                            )?.id
                        )
                        .map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.name}
                            style={{
                              direction: "rtl",
                            }}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>شماره حساب فعال</StyledImageTitle>
                  <Upload
                    isLocal={active_card_number.isChanged}
                    file={active_card_number.url}
                    refillable
                    type="active_card_number"
                    onChange={handleChangeImageactive_card_number}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>جواز کسب</StyledImageTitle>
                  <Upload
                    isLocal={business_license.isChanged}
                    file={business_license.url}
                    refillable
                    type="business_license"
                    onChange={handleChangeImagebusiness_license}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>تابلو سر در</StyledImageTitle>
                  <Upload
                    isLocal={rose_head_panel.isChanged}
                    file={rose_head_panel.url}
                    refillable
                    type="rose_head_panel"
                    onChange={handleChangeImagerose_head_panel}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>کارت ملی</StyledImageTitle>
                  <Upload
                    isLocal={national_card.isChanged}
                    file={national_card.url}
                    refillable
                    type="national_card"
                    onChange={handleChangeImagenational_card}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledImageTitle>صفحه اول شناسنامه</StyledImageTitle>
                  <Upload
                    isLocal={first_page_of_birth_certificate.isChanged}
                    file={first_page_of_birth_certificate.url}
                    refillable
                    type="first_page_of_birth_certificate"
                    onChange={handleChangeImagefirst_page_of_birth_certificate}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                </Grid>

                <ButtonContainer>
                  <Button
                    color="success"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ذخیره
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledWrapper>
          </Grid>
        </Grid>
      )}
    </DrawerCM>
  );
}
